<img class="feedback-image" src="/assets/images/unknown-error.png" alt="" />
<div class="message-container">
  <h1 class="message-container__header">Something went wrong!</h1>
  <p class="message-container__message">
    We aren't sure why you ended up here, but we can work through this together!
  </p>
  <app-further-assistance [showDefaultClientInfo]="true"></app-further-assistance>
</div>
